import React from 'react';
export function Footer() {
  return <footer className="bg-forest py-12 px-4 text-center" data-id="element-73">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-74">
        <h3 className="text-2xl font-heading font-bold text-cream" data-id="element-75">
          Menopausia en Control
        </h3>
        <p className="text-cream/80 text-lg" data-id="element-76">
          Guía Práctica de Nutrición y Hábitos
        </p>
        <div className="w-12 h-1 bg-gold/50 mx-auto my-6 rounded-full" data-id="element-77" />
        <p className="text-cream/60 italic font-heading text-xl" data-id="element-78">
          Tu cuerpo te lo agradecerá.
        </p>
        <p className="text-cream/40 text-sm mt-8" data-id="element-79">
          © {new Date().getFullYear()} Menopausia en Control. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}